/**
 * Whether the app has rendered once.
 *
 * Route loaders behave differently on the very first navigation than on later ones. On a
 * client-side navigation there is a page already on screen, so waiting for data is the whole
 * point — the user keeps looking at something real under a progress bar. On the initial load
 * there is nothing to preserve: blocking would leave the screen blank until the fetch returned,
 * which is worse than the shell rendering with a skeleton while the data arrives.
 *
 * React Router runs the initial navigation's loaders before it renders anything, so a flag set
 * during the first render cleanly separates the two cases.
 */
let hydrated = false;

export const hasHydrated = () => hydrated;

export const markHydrated = () => {
  hydrated = true;
};

/** Test seam — this is module state that would otherwise carry between cases. */
export const resetHydration = () => {
  hydrated = false;
};
